export function registerError(e: any, message: string = "") {
    let lr = (window as any).lr;

    if (!lr || !lr.api) {
        console.error(message, e);
        return;
    }

    const errorData = {
        source: 'abc.messenger'
    };

    if (e instanceof Error) {
        lr.api.registerException(e, errorData);
    } else {
        lr.api.registerError(e, null, errorData);
    }
}



// WEBPACK FOOTER //
// ./utils/registerError.ts